"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var AppLayout_1 = require("../AppLayout");
var SplashScreenBody_1 = require("./SplashScreenBody");
var helpers_1 = require("../../helpers");
var productTitleAndIconHeight = '94px';
var ReferenceHeightToTopPaddingRatio = '25%';
var padHeightValue = "calc(" + ReferenceHeightToTopPaddingRatio + " - " + productTitleAndIconHeight + ")";
var Root = styled_components_1.default(AppLayout_1.AppLayout)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    overflow: auto;\n"], ["\n    overflow: auto;\n"])));
var LangSelectorContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: ", " 0;\n"], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: ", " 0;\n"])), helpers_1.SIZE_L);
exports.SplashScreenLayout = helpers_1.createUIElement('SplashScreenLayout', function (_a, ref) {
    var className = _a.className, content = _a.content, minWidth = _a.minWidth, productImageSrc = _a.productImageSrc, footerControl = _a.footerControl, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "content", "minWidth", "productImageSrc", "footerControl", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (react_1.default.createElement(Root, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'splash-screen-layout', className: "vm-SplashScreenLayout " + className, minWidth: minWidth, body: react_1.default.createElement(SplashScreenBody_1.SplashScreenBody, { imageSrc: productImageSrc, body: react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { style: { height: padHeightValue, minHeight: helpers_1.SIZE_M } }),
                content,
                react_1.default.createElement("div", { style: { height: padHeightValue, minHeight: helpers_1.SIZE_M } })), footer: footerControl && (react_1.default.createElement(LangSelectorContainer, null, footerControl)) }), onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style })));
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=SplashScreenLayout.js.map